var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "margin-top": "40px",
      "margin-left": "40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n\t\t签约项目管理-解决方案\n\t")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 5%",
      "margin-top": "20px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "width": "100%",
      "background-color": "#FFFFFF",
      "padding": "10px 20px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "20px",
      "line-height": "27px",
      "font-weight": "600"
    }
  }, [_vm._v("\n\t\t\t\t解决方案A\n\t\t\t")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "background-color": "#3bcdd1",
      "color": "#FFFFFF",
      "font-size": "17px",
      "line-height": "27px",
      "margin-left": "10px",
      "display": "inline-block",
      "padding": "0 10px",
      "border-radius": "5px",
      "font-weight": "normal"
    }
  }, [_vm._v("\n\t\t\t\t100%符合客户要求\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "float": "right",
      "font-weight": "normal",
      "font-size": "19px"
    }
  }, [_c('span', [_vm._v("总需人数：")]), _vm._v("50\n\t\t\t\t"), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("每日应出勤人数：")]), _vm._v("50\n\t\t\t")])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "100%",
      "background-color": "#FFFFFF",
      "margin-top": "5px",
      "padding": "10px 20px"
    }
  }, _vm._l((_vm.ruleForm.projectPostList), function(item, index) {
    return _c('el-col', {
      key: index,
      staticStyle: {
        "margin-left": "1%",
        "background-color": "#fafafa",
        "padding": "1% 0",
        "padding-right": "10px"
      },
      attrs: {
        "span": 4
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block",
        "width": "10px",
        "height": "15px",
        "border-left": "3px #006E48 solid",
        "margin-top": "4px"
      }
    })]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "line-height": "24px",
        "font-weight": "bold",
        "font-size": "17px"
      },
      attrs: {
        "span": 22
      }
    }, [_vm._v("\n\t\t\t\t\t\t岗位:" + _vm._s(item.post_name) + "\n\t\t\t\t\t\t"), _c('hr')])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "offset": 2,
        "span": 22
      }
    }, [_vm._v("\n\t\t\t\t\t\t人数:  " + _vm._s(item.person_count) + "\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "offset": 2,
        "span": 22
      }
    }, [_vm._v("\n\t\t\t\t\t\t年龄:  " + _vm._s(item.age_start) + "-" + _vm._s(item.age_end) + "\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "offset": 2,
        "span": 22
      }
    }, [_vm._v("\n\t\t\t\t\t\t性别:  " + _vm._s(item.sex != '2' ? (item.sex == '0' ? '男' : '女') : '不限') + "\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "offset": 2,
        "span": 5
      }
    }, [_vm._v("\n\t\t\t\t\t\t班次:\n\t\t\t\t\t")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 17
      }
    }, _vm._l((item.shiftList), function(shift) {
      return _c('el-row', {
        key: shift.id
      }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(shift.shift) + ": " + _vm._s(shift.start_time) + "—" + _vm._s(shift.end_time) + "\n\t\t\t\t\t\t")])
    }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "offset": 2,
        "span": 22
      }
    }, [_vm._v("\n\t\t\t\t\t\t轮休方式:  上" + _vm._s(item.holiday_start) + "休" + _vm._s(item.holiday_end) + "\n\t\t\t\t\t")])], 1)], 1)
  }), 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73da87ce","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/znpb/QyxmGl/Jjfa_add.vue
// module id = null
// module chunks = 